module.exports = __webpack_public_path__ + "img/nycpg-logo-red.daa28045.svg";